import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { ScoreType } from '../Types'
import SmallBodyFont from '../../../../../Theme/Fonts/SmallBody'
import Label10Font from '../../../../../Theme/Fonts/Label10'
import ScoreIcon from './ScoreIcon'

type Props = {
    score?: string
    caption: string
    type: ScoreType
    scorePosition: 'right' | 'left'
}

const getTextColor = (type: ScoreType): 'onyx' | 'ORANGE' =>
    type === 'PERFECT' ? 'ORANGE' : 'onyx'

const DartsScore: FunctionComponent<Props> = ({ score, caption, type, scorePosition }) => {
    const components = [
        score ? (
            <SmallBodyFont
                key={`darts-score-${score}`}
                bold
                textAlign={scorePosition}
                color={getTextColor(type)}
            >
                {score}
            </SmallBodyFont>
        ) : null,
        <ScoreIcon
            type={type}
            key={`darts-score-type-${score}`}
            paddingBottom={scorePosition === 'right' ? 0 : 1}
        />,
    ]
    return (
        <Grid>
            <Grid
                horizontal
                centerVertical
                height={20}
                noExpand
                alignRight={scorePosition === 'right'}
            >
                {scorePosition === 'right' ? components.reverse() : components}
            </Grid>
            <Label10Font textAlign={scorePosition} color="pearl-4">
                {caption}
            </Label10Font>
        </Grid>
    )
}
export default DartsScore
